import { render, staticRenderFns } from "./ApprovalReference.vue?vue&type=template&id=21a3c1b3&scoped=true"
import script from "./ApprovalReference.vue?vue&type=script&lang=js"
export * from "./ApprovalReference.vue?vue&type=script&lang=js"
import style0 from "./ApprovalReference.vue?vue&type=style&index=0&id=21a3c1b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a3c1b3",
  null
  
)

export default component.exports